export const AUTH_USER = 'AUTH_USER';

export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';

export const GETLOG_SUCCESS = 'GETLOG_SUCCESS';
export const GET_ADMIN_LOG = 'GET_ADMIN_LOG';
export const GET_ISSUER_ADMIN_LOG = 'GET_ISSUER_ADMIN_LOG';

export const GETAPI_SUCCESS = 'GETAPI_SUCCESS';

export const GETROUTE_SUCCESS = 'GETROUTE_SUCCESS';

export const GETROUTE_CATEGORY_SUCCESS = 'GETROUTE_CATEGORY_SUCCESS';

export const GETISSUERS_SUCCESS = 'GETISSUERS_SUCCESS';

export const GETDASHBOARD_SUCCESS = 'GETDASHBOARD_SUCCESS';
export const GETBALANCE_SUCCESS = 'GETBALANCE_SUCCESS';

export const GETSTAFF_SUCCESS = 'GETSTAFF_SUCCESS';

export const GETTOPUP_SUCCESS = 'GETTOPUP_SUCCESS';

export const GETCLIENTS_SUCCESS = 'GETCLIENTS_SUCCESS';
export const GET_CLIENTS_STAFFS = 'GET_CLIENTS_STAFFS';

export const GET_SELF = 'GET_SELF';

export const GET_API_ACCESS_KEY = 'GET_API_ACCESS_KEY';

export const GET_REQ_HISTORY = 'GET_REQ_HISTORY';

export const GET_SECTION_ISSUER = 'GET_SECTION_ISSUER';
export const GET_SECTION_DATE = 'GET_SECTION_DATE';
export const GET_SECTION_API_ACCESS = 'GET_SECTION_API_ACCESS';
export const GET_SECTION_ROUTE = 'GET_SECTION_ROUTE';
export const GET_SECTION_ROUTE_CATEGORY = 'GET_SECTION_ROUTE_CATEGORY';
export const LOAD_REQUEST = 'LOAD_REQUEST';

export const GET_ROUTE_CATEGORIES = 'GET_ROUTE_CATEGORIES';
